var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9769 3.14436C11.3114 2.65409 10.4874 2.4286 9.66496 2.51168C8.84251 2.59476 8.08027 2.98046 7.52621 3.59393C6.97215 4.2074 6.6658 5.00485 6.66663 5.83149L6.66663 8.33233H15.8333C17.214 8.33233 18.3333 9.45161 18.3333 10.8323V16.6657C18.3333 18.0464 17.214 19.1657 15.8333 19.1657H4.16663C2.78591 19.1657 1.66663 18.0464 1.66663 16.6657V10.8323C1.66663 9.45161 2.78591 8.33233 4.16663 8.33233H4.99996V5.83268C4.99883 4.5929 5.45835 3.39691 6.28933 2.47683C7.12043 1.55663 8.26379 0.978064 9.49747 0.85345C10.7311 0.728837 11.9671 1.06706 12.9654 1.80247C13.9638 2.53788 14.6532 3.61801 14.9 4.83316C14.9915 5.28419 14.7002 5.72407 14.2491 5.81566C13.7981 5.90724 13.3582 5.61585 13.2666 5.16482C13.1021 4.35472 12.6425 3.63464 11.9769 3.14436ZM4.16663 9.99899C3.70639 9.99899 3.33329 10.3721 3.33329 10.8323V16.6657C3.33329 17.1259 3.70639 17.499 4.16663 17.499H15.8333C16.2935 17.499 16.6666 17.1259 16.6666 16.6657V10.8323C16.6666 10.3721 16.2935 9.99899 15.8333 9.99899H4.16663Z",
    fill: "#4C4D58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.8aab73ef23b7926aa02b3af40b3dce7e.svg";
export { ForwardRef as ReactComponent };